import { render, staticRenderFns } from "./Huangli.vue?vue&type=template&id=7459195b&scoped=true&"
import script from "./Huangli.vue?vue&type=script&lang=js&"
export * from "./Huangli.vue?vue&type=script&lang=js&"
import style0 from "./Huangli.vue?vue&type=style&index=0&id=7459195b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7459195b",
  null
  
)

export default component.exports